<template>
    <cadastro-simples-form
        endpoint="tipo-passe"
        rota-base="/admin/tipo-passe"
        titulo-singular="Tipo de Passe"
        :campos-extras="[{ campo: 'descricao', label: 'Descrição', tipo: 'text', span: 24 }]">
    </cadastro-simples-form>
</template>
<script>
import CadastroSimplesForm from '@/components/cadastros-auxiliares/cadastro-simples-form.vue'
export default { components: { CadastroSimplesForm } }
</script>
